<template>
  <div class="containerTable">
    <vxe-toolbar
      id="toolbarId_bc23"
      :custom="{ storage: true }"
      export
      :refresh="{ query: findList }"
    >
      <template v-slot:buttons>
        <el-button v-if="getLimit('staff_search_button')" @click="funcFilter">
          查询
        </el-button>
        <el-button v-if="getLimit('staff_add_button')" @click="funcEdit('add')">
          新增
        </el-button>
        <el-button v-if="getLimit('staff_export_button')" @click="funcExport">
          导出
        </el-button>
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      border
      resizable
      stripe
      highlight-current-row
      highlight-hover-row
      height="80%"
      :sort-config="{ remote: true }"
      export-config
      show-overflow
      align="center"
      :loading="loading"
      :data="tableData"
      @sort-change="sortList"
    >
      <vxe-table-column fixed="left" type="checkbox" width="60" />
      <vxe-table-column>
        <vxe-table-column
          field="branchCode"
          title="承运主体"
          :formatter="formatterBranch"
          min-width="150"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.branchCode"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in branchList"
              :key="item.code"
              :label="item.groupName"
              :value="item.code"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column field="name" title="名称" min-width="150" sortable />
        <template v-slot:header>
          <el-input v-model="listQuery.name" placeholder="请输入" clearable />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="phone"
          title="手机号"
          min-width="150"
          sortable
        />
        <template v-slot:header>
          <el-input v-model="listQuery.phone" placeholder="请输入" clearable />
        </template>
      </vxe-table-column>
      <!-- 角色 -->
      <vxe-table-column>
        <vxe-table-column
          field="roleList"
          title="角色"
          min-width="150"
          sortable
          :formatter="formatterRoleList"
        />
        <template v-slot:header>
          <!-- <el-select v-model="listQuery.roleCode" placeholder="请选择" clearable>
            <el-option v-for="item in roleList" :key="item.code" :label="item.roleName" :value="item.code" />
          </el-select> -->
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="gmtCreated"
          title="创建时间"
          min-width="420"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.gmtCreatedRange"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            :picker-options="optionsPicker"
            :default-time="['00:00:00', '23:59:59']"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'gmtCreated')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column title="操作" fixed="right" width="200">
        <template slot-scope="scope">
          <!-- 冻结、解冻 -->
          <el-tooltip
            v-if="getLimit('staff_freeze_button') && scope.row.status === 0"
            class="item"
            effect="dark"
            content="冻结"
            placement="top"
          >
            <vxe-button type="text" @click="handleFreeze(scope.row.code, 0)">
              <img
                style="width: 17px; height: 17px; position: relative; top: 4px"
                src="@/assets/icon/dongjie.png"
                alt=""
              />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="getLimit('staff_freeze_button') && scope.row.status === 1"
            class="item"
            effect="dark"
            content="解冻"
            placement="top"
          >
            <vxe-button type="text" @click="handleFreeze(scope.row.code, 1)">
              <img
                style="width: 14px; height: 16px; position: relative; top: 4px"
                src="@/assets/icon/jiedong.png"
                alt=""
              />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="getLimit('staff_update_button')"
            class="item"
            effect="dark"
            content="编辑"
            placement="top"
          >
            <vxe-button type="text" @click="funcEdit('edit', scope.row.code)">
              <em class="el-icon-edit" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="getLimit('staff_delete_button')"
            class="item"
            effect="dark"
            content="删除"
            placement="top"
          >
            <vxe-button type="text" @click="funcDelete(scope.row.code)">
              <em class="el-icon-delete" />
            </vxe-button>
          </el-tooltip>
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :current-page.sync="listQuery.pageNum"
      :page-size.sync="listQuery.pageSize"
      :total="listQuery.total"
      :page-sizes="Pagingconf"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />
    <vxe-modal
      v-model="modelEditFlag"
      :title="compTitle"
      width="600"
      height="400"
      resize
    >
      <compEdit
        ref="editRef"
        @fatherEditMethod="fatherEdit"
        @fatherCancelMethod="fatherCancel"
      />
    </vxe-modal>
    <downloadData ref="downloadRef" />
  </div>
</template>
<script>
import compEdit from "./components/partyEdit.vue";
import request from "@/utils/request";
export default {
  name: "PartyList",
  components: {
    compEdit
  },
  data() {
    return {
      exportObj: {
        exportUrl: "/ntocc-basic-api/party/exportParty", //导出接口
        name: "账号管理"
      },
      loading: false,
      //cascadeData: [],
      tableData: [],
      modelEditFlag: false,
      compTitle: "新增",
      listQuery: {
        gmtCreatedRange: "",
        partyType: "STAFF",
        name: "",
        phone: "",
        roleCode: "",
        gmtCreatedStart: "",
        gmtCreatedEnd: "",
        branchCode: "",
        departmentCode: "",
        teamCode: "",
        pageNum: 1,
        pageSize: 20,
        sortField: "",
        sortType: "",
        total: 0,
        isQueryRole: 1
      },
      roleList: [],
      // 机构列表
      branchList: this.$store.state.components.branchList
    };
  },
  created() {
    this.getRoleList();
    this.findList();
    //this.getCascadeData();
  },
  methods: {
    handleFreeze(code, num) {
      this.$confirm(`确认${num === 0 ? "冻结" : "解冻"}吗？`)
        .then(_ => {
          request({
            url: `/ntocc-basic-api/party/updateStatus?code=${code}`,
            method: "post"
          }).then(response => {
            this.$message({
              message: "冻结成功",
              type: "success"
            });
            this.findList();
          });
        })
        .catch(_ => {});
    },
    setOrgCode(value) {
      this.listQuery.branchCode = value[0];
      this.listQuery.departmentCode = value[1];
      this.listQuery.teamCode = value[2];
    },
    formatterRoleList({ cellValue }) {
      return cellValue.map(item => item.roleName).join(",");
    },
    groupNameFormatter({ row }) {
      let gropName = row.branchName;
      if (row.departmentName) gropName = gropName + " / " + row.departmentName;
      if (row.teamName) gropName = gropName + " / " + row.teamName;
      return gropName;
    },
    // 获取字典数据
    /*getCascadeData() {
      request({
        url: "/ntocc-basic-api/team/cascadeData",
        method: "get",
      }).then((response) => {
        this.cascadeData = response.data;
        this.findList();
      });
    },*/
    findList() {
      return new Promise(resolve => {
        this.loading = true;
        request({
          url: "/ntocc-basic-api/party",
          method: "get",
          params: this.listQuery
        }).then(response => {
          this.tableData = response.data.records;
          this.listQuery.total = response.data.total;
          this.loading = false;
          resolve();
        });
      });
    },
    changeCascade(value) {
      this.listQuery.branchCode = value[0] ? value[0] : "";
      this.listQuery.departmentCode = value[1] ? value[1] : "";
    },
    // 查询角色列表
    getRoleList() {
      request({
        url: `/ntocc-basic-api/role`,
        method: "get",
        params: { type: 0 }
      }).then(response => {
        this.roleList = response.data.records;
      });
    },
    // 翻译机构
    formatterBranch({ cellValue }) {
      const item = this.branchList.find(item1 => item1.code === cellValue);
      return item ? item.groupName : "";
    },
    // 修改方法
    funcEdit(type, code) {
      let title = type == "edit" ? "编辑" : "详情";
      this.compTitle = type == "add" ? "新增" : title;
      this.$refs.editRef.getInfo(type, code);
      this.modelEditFlag = true;
    },
    // 删除方法
    funcDelete(row) {
      this.$confirm("确认删除吗？")
        .then(_ => {
          request({
            url: `/ntocc-basic-api/party/`,
            method: "delete",
            params: { codes: row }
          }).then(response => {
            this.$message({ message: response.msg, type: "success" });
            this.findList();
          });
        })
        .catch(_ => {});
    },
    // 编辑组件的父方法
    fatherEdit() {
      this.modelEditFlag = false;
      this.findList();
    },
    // 公共取消
    fatherCancel(modelFlag) {
      switch (modelFlag) {
        case "edit":
          this.modelEditFlag = false;
          break;
        default:
      }
    },
    // 角色名
    formatterRoleName({ cellValue }) {
      let roleNames = "";
      if (cellValue && cellValue.length > 0) {
        cellValue.forEach(function(val, index, arr) {
          roleNames += val.roleName + " ";
        });
      }
      return roleNames;
    }
  }
};
</script>

<style lang="scss" scoped>
.vxe-table {
  ::v-deep.el-date-editor {
    width: 100%;
  }
}
</style>
